import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { PricePerRoomMappingService } from "./price-per-room-mapping.service";
import { PricePerRoomComponent } from "./price-per-room-component";
import { LabelModule } from "libraries/service/label/label.module";
import { BtnModule } from "libraries/ui_button/btn.module";
import { PriceModule } from "libraries/component/price/price.module";
import { FindRoomPipe } from "./find-room.pipe";
import { FindRoomNamePipe } from "./find-room-name.pipe";
import { MatDialogModule } from "@angular/material/dialog";
import { MatTableModule } from "@angular/material/table";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

@NgModule({
    imports: [
        CommonModule,
        LabelModule,
        BtnModule,
        MatDialogModule,
        MatTableModule,
        PriceModule,
        FontAwesomeModule,
    ],
    exports: [
        PricePerRoomComponent,
    ],
    declarations: [
        PricePerRoomComponent,
        FindRoomPipe,
        FindRoomNamePipe,
    ],
    providers: [
        PricePerRoomMappingService,
    ],
    entryComponents: [
        PricePerRoomComponent,
    ]
})
export class PricePerRoomModule {
}
